import { defineMessages } from "react-intl";

const namespace = `businessReferral`;
const businessReferral = defineMessages({
  lang: {
    id: `${namespace}.lang`,
    description: "Language Field",
    defaultMessage: "Language"
  },
  numOfEmployees: {
    id: `${namespace}.numOfEmployees`,
    description: "Number of Employees Field",
    defaultMessage: "Number of Employees"
  },
  personalEmailSubtext: {
    id: `${namespace}.personalEmailSubtext`,
    description: "Personal Email Subtext",
    defaultMessage: "If you have an Evo account add your email here so we can send free mins your way"
  },
  businessNameText: {
    id: `${namespace}.businessNameText`,
    description: "Business Name Text Field",
    defaultMessage: "What business are you referring?"
    },
  businessContactSectionTitle: {
    id: `${namespace}.businessContactSectionTitle`,
    description: "Business Contact Section Title",
    defaultMessage: "Business contact"
    },
  businessGetInTouchSubtext: {
    id: `${namespace}.businessGetInTouchSubtext`,
    description: "Business Get In Touch Subtext",
    defaultMessage: "Let us know how we can get in touch with them!"
    },
  additionalInfoText: {
    id: `${namespace}.additionalInfoText`,
    description: "Additional Info Text Field",
    defaultMessage: "Additional info"
    },
  companyName: {
    id: `${namespace}.companyName`,
    description: "Company Name Field",
    defaultMessage: "Company name"
  },
  industry: {
    id: `${namespace}.industry`,
    description: "Industry Field",
    defaultMessage: "Industry"
  },
  message: {
    id: `${namespace}.message`,
    description: "Message Field",
    defaultMessage: "Message"
  },
  title: {
    id: `${namespace}.title`,
    description: "Page Title",
    defaultMessage: "Refer a business"
  },
  description: {
    id: `${namespace}.description`,
    description: "Page Description",
    defaultMessage: `Know an amazing business that needs Evo? Let us know and you could get 60 free mins (almost $30) if they sign up for a business account.`
  },
  successMessage: {
    id: `${namespace}.successMessage`,
    description: "Success Message",
    defaultMessage: `Success!`
  },
  successMessageDescription: {
    id: `${namespace}.successMessageDescription`,
    description: "Success Message Description",
    defaultMessage: `Thanks for sending an amazing business our way – keep an eye on your inbox because you’ll score 60 mins on us if they hop in and drive.`
  },
  contactInfoTitle: {
    id: `${namespace}.contactInfoTitle`,
    description: "Contact Info Title",
    defaultMessage: "Your contact info"
  },
  firstName: {
    id: `${namespace}.firstName`,
    description: "First Name Field",
    defaultMessage: "First Name"
    },
  lastName: {
    id: `${namespace}.lastName`,
    description: "Last Name Field",
    defaultMessage: "Last Name"
  },
  phone: {
    id: `${namespace}.phone`,
    description: "Phone Field",
    defaultMessage: "Phone number"
  },
  email: {
    id: `${namespace}.email`,
    description: "Email Field",
    defaultMessage: "Email"
  }
});

export default businessReferral;
